<template>
  <div class="reset-password">
    <Modal
      v-if="modalActive"
      :modalMessage="modalMessage"
      @close-modal="closeModal"
    />
    <Loading v-if="loading" />
    <!--
        @close-modal and v-on:close-modal, both work same
        -->
    <div class="form-wrap">
      <form class="reset">
        <img @click.prevent="goHome" src="../assets/home.jpeg" alt="Home" />
        <p class="login-register">
          Back To
          <router-link class="router-link" :to="{ name: 'Login' }">
            Log In</router-link
          >
        </p>
        <h2>Reset Your Password</h2>
        <p>Forgot Your Password? Enter Your Email To Reset It!</p>
        <div class="inputs">
          <div class="input">
            <input type="text" placeholder="Email" v-model="email" />
            <email class="icon" />
          </div>
        </div>
        <div class="error-message" v-if="errorInEmail">
          <p>{{ errorMsg }}</p>
        </div>
        <button @click.prevent="resetPassword">Reset</button>
        <div class="angle"></div>
      </form>
      <div class="background"></div>
    </div>
  </div>
</template>

<script>
import email from "../assets/Icons/envelope-regular.svg";
import Modal from "../components/Modal";
import Loading from "../components/Loading";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "ForgotPassword",
  components: {
    email,
    Modal,
    Loading,
  },
  data() {
    return {
      modalActive: false,
      modalMessage: "",
      loading: false,
      email: "",
      errorInEmail: false,
      errorMsg: null,
    };
  },
  methods: {
    goHome() {
      this.$router.push({ name: "Home" });
    },
    resetPassword() {
      this.loading = true;
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.modalMessage =
            "If You're Registered With Us, You Would Get An Email Shortly!";
          this.loading = false;
          this.modalActive = true;
        })
        .catch((err) => {
          this.errorMsg = err.message;
          this.loading = false;
          this.errorInEmail = true;
        });
    },
    closeModal() {
      this.modalActive = !this.modalActive;
      this.email = "";
      this.$router.push({ name: "Login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.reset-password {
  position: relative;
  .form-wrap {
    .reset {
      h2 {
        margin-bottom: 8px;
      }

      p {
        text-align: center;
        margin-bottom: 32px;
      }

      .error-message {
        p {
          color: rgb(255, 18, 18);
          margin: 0;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
